<template>
  <div class="app-container">
    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-select class="filter-item" filterable v-model="listQuery.stationmaster_id" placeholder="请选择站长" style="width: 140px" clearable>
        <el-option v-for="item in stationmasters" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <el-input v-model="listQuery.order_no" placeholder="请输入订单号" class="filter-item" style="width: 250px;" clearable />

      <el-select v-model="listQuery.split_order_status" placeholder="分账订单状态" class="filter-item" style="width: 140px;" clearable>
        <el-option label="无需分账" :value="0" />
        <el-option label="待分账" :value="1" />
        <el-option label="分账中" :value="2" />
        <el-option label="分账完成" :value="3" />
        <el-option label="分账失败" :value="4" />
      </el-select>

      <el-select v-model="listQuery.is_finish_split" placeholder="是否完结分账" class="filter-item" style="width: 140px;" clearable>
        <el-option label="未完结分账" :value="0" />
        <el-option label="已完结分账" :value="1" />
      </el-select>

      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button type="primary" class="filter-item" @click="handleFilter">搜索</el-button>

      <download-excel :fields="json_fields" :fetch="handleExport" type="xls" name="站长充值订单.xls" worksheet="站长充值订单">
        <el-button type="success" :loading="exportLoading">导出</el-button>
      </download-excel>
    </div>

    <div v-loading="listLoading" style="margin-bottom: 20px;">
      <el-row :gutter="20">
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payMoney || 0 }}</div>
            <div class="subtitle">累计消费金额</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payCount || 0 }}</div>
            <div class="subtitle">累计消费次数</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div style="margin-bottom: 20px;">
      <span style="font-size:18px;margin-left:30px;">分账总额：{{ledgerMoney}}</span>
      <span style="font-size:18px;margin-left:30px;" v-for="(item,index) in ledgerRole" :key="index">{{item.role_name}}：{{item.ledger_role_money}}</span>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <el-table-column label="分账单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.split_order_no }}
        </template>
      </el-table-column>

      <el-table-column label="站长" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <img :src="scope.row.stationmaster.avatar" class="user-avatar">
            <span>{{ scope.row.stationmaster.name }}</span>
            <span>{{ scope.row.stationmaster.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="支付用户" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <img :src="scope.row.user.avatar" class="user-avatar">
            <span>{{ scope.row.user.name }}</span>
            <span>{{ scope.row.user.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="支付金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_money }}
        </template>
      </el-table-column>

      <el-table-column label="支付状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.pay_status === 0">待支付</el-tag>
          <el-tag type="success" v-else-if="scope.row.pay_status === 1">已支付</el-tag>
          <el-tag type="danger" v-else-if="scope.row.pay_status === 2">已取消</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="支付时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_time }}
        </template>
      </el-table-column>

      <el-table-column label="分账订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.split_order_status === 0">无需分账</el-tag>
          <el-tag type="info" v-else-if="scope.row.split_order_status === 1">待分账</el-tag>
          <el-tag type="warning" v-else-if="scope.row.split_order_status === 2">分账中</el-tag>
          <el-tag type="success" v-else-if="scope.row.split_order_status === 3">分账完成</el-tag>
          <el-tag type="danger" v-else-if="scope.row.split_order_status === 4">分账失败</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="分账错误原因" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.split_order_status === 4 ? scope.row.split_error_msg : "" }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="250" align="center" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="handleStationmasterChargeOrderSplitLog(scope.row)">分账收入记录</el-button>

          <el-button type="warning" size="mini" @click="handleStationmasterChargeOrderFinishSplit(scope.row)" :disabled="(scope.row.split_order_status !== 0 && scope.row.split_order_status !== 4) || scope.row.is_finish_split === 1">完结分账</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5, 10, 20, 30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
import downloadExcel from "vue-json-excel";
var moment = require("moment");

export default {
  components: {
    downloadExcel
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        school_id: "",
        stationmaster_id: "",
        order_no: "",
        split_order_status: "",
        is_finish_split: "",
        start_date: "",
        end_date: "",
      },
      dateArr: null,
      ledgerMoney: null,
      ledgerRole: null,
      payMoney: null,
      payCount: null,
      stationmasters: [],
      json_fields: {
        订单号: {
          field: "order_no",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        分账单号: {
          field: "split_order_no",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        站长: "stationmaster.name",
        支付用户: "user.name",
        支付金额: "pay_money",
        支付状态: {
          field: "pay_status",
          callback: (value) => {
            if (value === 0) return "待支付";
            else if (value === 1) return "已支付";
            else if (value === 2) return "已取消";
            else return "";
          }
        },
        支付时间: {
          field: "pay_time",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        分账订单状态: {
          field: "split_order_status",
          callback: (value) => {
            if (value === 0) return "无需分账";
            else if (value === 1) return "待分账";
            else if (value === 2) return "分账中";
            else if (value === 3) return "分账完成";
            else if (value === 4) return "分账失败";
            else return "";
          }
        },
        分账错误原因: "split_error_msg",
      },
      exportLoading: false,
    };
  },
  created() {
    this.listQuery.start_date = moment().format("YYYY-MM-DD");
    this.listQuery.end_date = moment().format("YYYY-MM-DD");
    this.dateArr = [this.listQuery.start_date, this.listQuery.end_date];
    this.getList();
    this.getStationmasterList();
  },
  computed: {
    ...mapGetters(["schools", "school_id", "user"])
  },
  watch: {
    school_id(newVal, oldVal) {
      this.listQuery.school_id = newVal;
      this.getList();
      this.getStationmasterList();
    },
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_date = newVal[0];
        this.listQuery.end_date = newVal[1];
      } else {
        this.listQuery.start_date = "";
        this.listQuery.end_date = "";
      }
    }
  },
  methods: {
    getList() {
      this.listQuery.school_id = this.school_id;
      this.listLoading = true;
      request({
        url: "/api/backend/stationmasterChargeOrder/list",
        method: "get",
        params: this.listQuery,
        timeout: 6000000,
      }).then((response) => {
        this.list = response.data.list.data;
        this.total = response.data.list.total;
        this.ledgerMoney = response.data.ledgerMoney;
        this.ledgerRole = response.data.ledgerRole;
        this.payMoney = response.data.payMoney;
        this.payCount = response.data.payCount;
        this.listLoading = false;
      });
    },
    getStationmasterList() {
      request({
        url: "/api/backend/stationmaster/list",
        method: "get",
        params: {
          page: 1,
          limit: 1000000,
          school_id: this.school_id,
        }
      }).then(response => {
        this.stationmasters = response.data.data;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleStationmasterChargeOrderSplitLog(item) {
      this.$router.push(`/stationmaster/chargeOrderSplitLog?order_no=${item.order_no}`);
    },
    handleStationmasterChargeOrderFinishSplit(item){
      request({
        url: "/api/backend/stationmasterChargeOrder/finishSplit",
        method: "post",
        data: {
          order_no: item.order_no
        }
      }).then(() => {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.getList();
      });
    },
    handleExport() {
      if (!this.listQuery.start_date || !this.listQuery.end_date) {
        this.$message({
          type: "warning",
          message: "请选择时间段"
        });
        return;
      }

      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.page = 1;
      listQuery.limit = this.total;
      this.exportLoading = true;
      return request({
        url: "/api/backend/stationmasterChargeOrder/list",
        method: "get",
        params: listQuery,
        timeout: 6000000,
      }).then(response => {
        if (response.data.list.data.length <= 0) {
          this.$message({
            type: "warning",
            message: "暂无记录"
          });
          return;
        }
        return response.data.list.data;
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .box-card {
    text-align: center;
    .value {
      color: #546DFE;
      font-weight: bold;
      font-size: 26px;
    }
    .subtitle {
      font-size: 12px;
      color: gray;
      margin-top: 6px;
    }
  }
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
</style>
